import { t } from 'ttag';
import * as Yup from 'yup';
import { getPhoneValidation } from '../../../utils/validations';
import { passwordRuleMessage, PASSWORD_REGEX } from '../../../services/formService';

// Validation schema for new user
export const createValidationSchema = (inviteInfo) => {
  const baseSchema = {
    firstName: Yup.string()
      .required(t`Required`)
      .max(20, t`First name must be less than 20 characters`),
    lastName: Yup.string()
      .required(t`Required`)
      .max(20, t`Last name must be less than 20 characters`),
    password: Yup.string()
      .matches(PASSWORD_REGEX, passwordRuleMessage)
      .required(t`Required`),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], t`Passwords must match`)
      .required(t`Confirm password is required`),
    email: Yup.string()
      .required(t`Required`)
      .test(
        "email validation",
        t`Invalid email`,
        (value) => {
          if (!value) return true;
          const emailSchema = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return emailSchema.test(String(value).toLowerCase());
        }
      ),
    phone: getPhoneValidation(),
    timeFormat: Yup.number().required(),
    dateFormat: Yup.number().required(),
    temperatureScale: Yup.number().required(),
  };

  if (inviteInfo?.setSubscription) {
    return Yup.object().shape({
      ...baseSchema,
      subscriptionCode: Yup.string().required(t`This field is required for service providers!`)
    });
  }

  return Yup.object().shape({
    ...baseSchema,
    subscriptionCode: Yup.string()
  });
};

// Validation schema for existing user login
export const createLoginValidationSchema = (inviteInfo) => {
  const baseSchema = {
    password: Yup.string().required(t`Required`),
    username: Yup.string().required(t`Required`).min(6, t`Too Short!`).max(50, t`Too Long!`),
  };

  if (inviteInfo?.setSubscription) {
    return Yup.object().shape({
      ...baseSchema,
      subscriptionCode: Yup.string().required(t`This field is required for service providers!`)
    });
  }

  return Yup.object().shape({
    ...baseSchema,
    subscriptionCode: Yup.string()
  });
};
